import React from 'react';
import TableManager from '../components/data/TableManager'; // Assicurati che il path sia corretto

// Definisci qui la configurazione delle colonne o importala
const columnConfig = [
   "FUA_Id_FunzioniApp=1,ID", // Primary Key, ReadOnly
  "FUA_IdRif_FunzioniApp=1,ID Riferimento", // Lookup to self
  "FUA_CodiceFunzione=2,Codice Funzione", // Required
  "FUA_NomeFunzione=2,Nome Funzione", // Required
  "FUA_Componente=2,Componente Frontend",
  "FUA_RottaFrontend=2,Rotta Frontend",
  "FUA_RottaBackend=2,Rotta Backend",
  "FUA_ModuloApplicativo=2,Modulo Applicativo",
  "FUA_NomeTabella=2,Nome Tabella Collegata",
  "FUA_UtenteInserimento=0,Utente Inserimento", // Audit, ReadOnly
  "FUA_DataOraInserimento=0,Data/Ora Inserimento", // Audit, ReadOnly
  "FUA_TerminaleInserimento=0,Terminale Inserimento", // Audit, ReadOnly
  "FUA_UtenteModifica=0,Utente Modifica", // Audit, ReadOnly
  "FUA_DataOraModifica=0,Data/Ora Modifica", // Audit, ReadOnly
  "FUA_TerminaleModifica=0,Terminale Modifica", // Audit, ReadOnly
  "FUA_InizioValidita=0,Inizio Validità", // Managed by backend? ReadOnly for now
  "FUA_FineValidita=0,Fine Validità", // Managed by backend? ReadOnly for now
  "FUA_StatoRecord=0,Stato Record", // Managed by backend? ReadOnly for now
  "FUA_Utente=0,Utente Audit", // Audit, ReadOnly
  "FUA_Terminale=0,Terminale Audit", // Audit, ReadOnly
  "FUA_Timestamp=0,Timestamp" // Audit, ReadOnly
];

// Definisci la configurazione dei filtri
const filterConfig = [
  { field: 'FUA_CodiceFunzione', label: 'Codice Funzione', type: 'text' },
  { field: 'FUA_NomeFunzione', label: 'Nome Funzione', type: 'text' },
  { field: 'FUA_ModuloApplicativo', label: 'Modulo Applicativo', type: 'text' },
  { field: 'FUA_NomeTabella', label: 'Nome Tabella', type: 'text' },
];

// Definisci la configurazione per i lookup necessari
const lookupConfig = {
  
  // Aggiungi altre configurazioni lookup se necessarie per altri campi
};

// Definisci tipi di input specifici se necessario (es. textarea)
const inputTypes = {
  // Esempio: FUA_DescrizioneLunga: 'textarea',
};

const FunzioniAppPage = () => {
  return (
    <TableManager
      tableName="SKE_FunzioniApp"
      primaryKey="FUA_Id_FunzioniApp" // Chiave primaria della tabella
      
      pageTitle="Gestione Funzionalità Applicative"
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      // Puoi aggiungere initialFilters, enableCreate/Edit/Delete se necessario
      // initialFilters={{ FUA_StatoRecord: 'A' }}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true} // Attenzione all'eliminazione logica vs fisica
    />
  );
};

export default FunzioniAppPage;